import login from './login'
import FetchTenant from './SuperAdmin/FetchTenant'
import TenantCreation from './SuperAdmin/TenantCreation'
import TenantCreateUserForm from './Tenant/TenantCreateUserForm'
import TenantCreatedFetchUser from './Tenant/TenantCreatedFetchUser'
import Documents from './Tenant/Documents'
import AddDocuments from './Tenant/AddDocuments'

import { reducer as toastr} from 'react-redux-toastr'


export default {
    login,
    FetchTenant,
    TenantCreation,
    TenantCreateUserForm,
    TenantCreatedFetchUser,
    toastr,
    Documents,
    AddDocuments
}